import React = require('react')
import { CookieSettingsState, getCookieStatus } from './cookiebar.utils.mod'

export interface CookieSensitiveContentWrapperProps {
  children: React.ReactNode
  placeholder?: React.ReactNode
  groupId: number
  button?: string
  options?: { style?: CookieSensitiveContentWrapperStyle; key?: string }
}

export type CookieSensitiveContentWrapperStyle = Partial<{
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>

export class CookieSensitiveContentWrapper extends React.Component<
  CookieSensitiveContentWrapperProps,
  CookieSettingsState
> {
  constructor(props: CookieSensitiveContentWrapperProps) {
    super(props)

    this.state = {
      error: false,
      cookieStatus: getCookieStatus(this.props.groupId),
      unsubListener: () => {}
    }

    this.handleCookieEvent = this.handleCookieEvent.bind(this)
  }

  handleCookieEvent() {
    this.setState({ error: false, cookieStatus: getCookieStatus(this.props.groupId) })
  }

  componentDidMount() {
    window.addEventListener('CookiesUpdated', this.handleCookieEvent)
  }

  componentWillUnmount() {
    window.removeEventListener('CookiesUpdated', this.handleCookieEvent)
  }

  componentDidCatch() {
    this.setState({ error: true })
  }

  render() {
    return this.state.error && this.state.cookieStatus == 'undecided' ? (
      this.props.placeholder ? (
        <div
          className={`error ${
            this.props.options.style.cookies_classname
              ? this.props.options.style.cookies_classname
              : 'text-center bg-light'
          }`}
        >
          <div
            className={
              this.props.options.style.cookies_inner_classname
                ? this.props.options.style.cookies_inner_classname
                : 'p-5'
            }
          >
            <div
              className={
                this.props.options.style.cookies_text_classname ? this.props.options.style.cookies_text_classname : ''
              }
            >
              {this.props.placeholder}
            </div>
          </div>
        </div>
      ) : (
        <></>
      )
    ) : this.state.cookieStatus == 'accepted' ? (
      this.props.children
    ) : this.props.placeholder ? (
      <div
        className={
          this.props.options.style.cookies_classname
            ? this.props.options.style.cookies_classname
            : 'text-center bg-light'
        }
      >
        <div
          className={
            this.props.options.style.cookies_inner_classname ? this.props.options.style.cookies_inner_classname : 'p-5'
          }
        >
          <div
            className={
              this.props.options.style.cookies_text_classname ? this.props.options.style.cookies_text_classname : ''
            }
          >
            {/* <p> */}
            {this.props.placeholder}
            {/* </p> */}
            {/* <p>
                      <div dangerouslySetInnerHTML={{__html:this.props.button}}/>
                    </p> */}
          </div>
          {/* <button
                    className={this.props.options.style.cookies_clickable_classname ? this.props.options.style.cookies_clickable_classname : 'btn btn-dark'}
                    onClick={_ => {
                      setCookie('cookies', 'accepted', 86400)
                      this.setState(s => ({ ...s, cookieStatus: 'accepted' }))
                    }}
                  >
                    {this.props.button ? this.props.button : "Accepteer cookies"}
                  </button> */}
        </div>
      </div>
    ) : (
      <></>
    )
  }
}
